import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import '../../../styles/bookingLayout.css';
import BookingBox from './BookingBox';
import { getLastURLSegment, getValueByTarget } from '../../../utils/parse';
import { useBookingOptionContext, withBookingProvider } from '../../organisms/BookingOptionContext';
import { BookingEstimateSteps } from '../../../utils/steps';
import Header from '../../molecules/Header';
import Steps from '../../atoms/Steps';
import useCheckPC from '../../../hooks/useCheckPC';
import { getEstimateHistoryInfo } from '../../../lib/EstimateApi';
import { getEstimateCookieData, getQueryStringObject, isChkEstimateCookieData, base64EncodeUnicode, getKeyByIndex, sleep, isDev } from '../../../lib/Util';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateAll } from '../../../reducers/bookingEstimation';
import { URLS } from '../../../utils/urls';
import { closeLoading, openLoading } from '../../../reducers/loadingRedux';
import { BookingProducts, UsageTimeOptionsMonthly } from '../../../utils/EstimateFormData';
import { updateSelect } from '../../../reducers/monthlyContractMonthArray';
import ShareButton from '../../etc/ShareButton';
import KakaoButton from '../../etc/KakaoButton'
import AppDownloadButton from '../../etc/AppDownloadButton';
import moment from 'moment';

 const isNullOrUndefined = (value) => {
  return value === null || value === undefined;
}


const BookingEstimation = () => {
  const { isPC } = useCheckPC();
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState([]);
  const [stepList, setStepList] = useState([])
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { selectedOptions, setSelectedOptions } = useBookingOptionContext();

  useEffect(() => {
    if (location.pathname) {
      const currentPath = location.pathname;
      const transformedPath = getLastURLSegment(currentPath);
      const stepList = BookingEstimateSteps[transformedPath]
      setCurrentStep(stepList);
    }
    const uniqueStepTitles = Array.from(new Set(Object.values(BookingEstimateSteps).map(step => step.title)));

    setStepList(uniqueStepTitles)
    document.title = '월간모시러 웹 견적서'
  }, [location, BookingEstimateSteps])


  const getSituationPageLink = (idx) => {
    let retData = ''
    // 견적서 진입 완료시
    if (idx === 4 || idx === 5) {
      retData = URLS.BOOKING_ESTIMATION_CONFIRM_ESTIMATE
    }
    // 계약 초안화면 진입 완료시
    else if (idx === 6) {
      retData = URLS.BOOKING_ESTIMATION_CONFIRM_CONTRACT
    }
    // 계약 완료시
    else if (idx === 7) {
      retData = URLS.BOOKING_ESTIMATION_COMPLETE_CONTRACT
    }
    else {
      retData = URLS.BOOKING_ESTIMATION_USAGE_TIME
    }
    return retData;

  }

  useEffect(() => {
    const initEstimateInfo = async () => {
      let reqData = ''
      let plainData = ''
      let isData = false
      let result = {}

      try {
        let qs = getQueryStringObject()

        if (qs.estimateinfo.length) {
          reqData = qs.estimateinfo // estimateinfo를 복호화 된 데이터를 넣는다.
          isData = true;
        }

      }
      catch (e) {
        // 쿠키 체크
        if (isChkEstimateCookieData()) {
          reqData = getEstimateCookieData()
          isData = true;
        }
      }

      plainData = decodeURIComponent(atob(reqData))

      if (isData) {
        try {
          result = await getEstimateHistoryInfo(base64EncodeUnicode(plainData), 1)
          if (result.Item.ResultCode === 200) {
            dispatch(openLoading())
            let updateFlag = false;

            let resultJson = JSON.parse(result.ItemArray[0].JsonData)
            // 월간모시러라면 초기화 시켜야함
            // 연간모시러라면 100시간 200시간 300시간 선택했을 경우 초기화 시켜야함
            // 그 이외에는 기존대로 처리
            if (resultJson?.subscription === 'monthly') {
              updateFlag = false
            }
            else if (resultJson?.subscription === 'annual') {
              console.log(resultJson?.contractTerms1?.schedule)
              // 데이터가 있을 경우
              if (!isNullOrUndefined(resultJson?.contractTerms1?.schedule)) {
                
                // 서버에 저장되어있는 스케줄 데이터가 릴리즈일 보다 이전이라면
                if (moment(resultJson?.contractTerms1?.schedule).isBefore(moment('2026-06-15'))) {
                  // 초기화 실시
                  updateFlag = false
                } 
                // 서버에 저장되어있는 스케줄 데이터가 릴리즈일 이후라면
                else {
                  updateFlag = true
                }
              }
              // 데이터가 없을 경우
              else {
                // 초기화
                updateFlag = false
              }
              // if (
              //   resultJson?.usageTime?.indexOf('annual_1year_100h') >= 0 ||
              //   resultJson?.usageTime?.indexOf('annual_1year_200h') >= 0 ||
              //   resultJson?.usageTime?.indexOf('annual_1year_300h') >= 0
              // ) {
              //   updateFlag = false
              // }
            }
            else {
              updateFlag = true
            }
            



            console.log(updateFlag)
            // console.log(resultJson?.contractTerms1)
            // let scheduleUpdate = ''
            // let AddressUpdate = ''
            // /*
            // 현재 날짜가 2025-01-21 이전이라면
            // 데이터 리셋
            // 현재 날짜가 2025-01-21 이후라면
            // 데이터를 리셋하지 않는다.
            
            // */
            
            // // 스케줄 데이터가 존재한다면
            // if (!isNullOrUndefined(resultJson?.contractTerms1?.schedule)) {

            //   // 서버에 저장되어있는 스케줄 데이터가 릴리즈일 보다 이전이라면
            //   if (moment(resultJson?.contractTerms1?.schedule).isBefore(moment('2025-01-22'))) {
            //     // 데이터를 RESET한다.
            //     scheduleUpdate = moment().add(1, 'days').format('yyyy-MM-DD')
            //     AddressUpdate = ''
            //   }
            //   else {
            //     scheduleUpdate = resultJson?.contractTerms1?.schedule
            //     AddressUpdate = resultJson?.contractTerms1?.serviceArea?.departure?.address1
            //   }

            //   console.log(scheduleUpdate, AddressUpdate)
              
            // }

            if (updateFlag) {
              setSelectedOptions({ ...resultJson })

              // //월간모시러 금액  2950000 * 0.03 = 88500 / 2950000 *  0.07 = 206500
              // if (resultJson.subscription === 'monthly') {
              //   let MmPlusUsage = getValueByTarget(BookingProducts, resultJson.subscription, 'price') + getValueByTarget(UsageTimeOptionsMonthly, resultJson.usageTime, 'price')
              //   dispatch(updateSelect([
              //     {
              //       title: '1개월',
              //       value: 'month1',
              //       category: 'periodOfContract',
              //       numberValue: 1,
              //       discount: 0,
              //       description: '기본 비용 / 할인 없음',
              //       descriptionTitle: '할인 없음'
              //     },
              //     {
              //       title: '4개월',
              //       value: 'month4',
              //       category: 'periodOfContract',
              //       numberValue: 4,
              //       discount: Math.floor(MmPlusUsage * 0.03),
              //       description: '4개월 할인',
              //       descriptionTitle: '할인율 3%'
              //     },
              //     {
              //       title: '12개월',
              //       value: 'month12',
              //       category: 'periodOfContract',
              //       numberValue: 12,
              //       discount: Math.floor(MmPlusUsage * 0.07),
              //       description: '12개월 할인',
              //       descriptionTitle: '할인율 7%'
              //     },
              //   ]))
  
              // }
  
              dispatch(updateAll(resultJson))
              //booking context에도 반영
  
              await sleep(500)
              // navigate(`/booking/${getKeyByIndex(BookingEstimateSteps, result.ItemArray[0].EstimatePage)}`)
              navigate(getSituationPageLink(Number(result.ItemArray[0].EstimatePage)))
  
            }
            else {
              const initialBookingOption = {
                subscription: 'annual',
                usageTime: 'annual_1year_100h',
                optionHex: 0,
                vehicleOption: {
                  numberOfVehicles: 'twoVehicles',
                  roleOfVehicles: 'driver',
                  carAmount: 'twomilliondown',
                  insurance: 'insubasic',
                  passengerPerson: 'persontwo'
                },
                contractTerms1: {
                  periodOfContract: 'month1',
                  serviceArea: {
                    departure: {
                      zip: '',
                      address1: '',
                      address2: '',
                    },
                    destination: {
                      zip: '',
                      address1: '',
                      address2: '',
                    },
                  },
                  schedule: moment().add(1, 'days').format('yyyy-MM-DD'),
                },
                contractTerms2: {
                  purposeOfContract: 'business',
                  passenger: 'ceo',
                  passengerEtcString: '',
                  route: 'route_instagram',
                  routeEtcString: '',
                  vehicleName1: '',
                  vehicleName2: '',
                  vehicleName3: '',
                },
                userInformation: {
                  userType: 'personal',
                  user: {
                    name: '',
                    businessAddress: {
                      zip: '',
                      address1: '',
                      address2: '',
                    },
                    businessRegistrationId: '',
                    businessRegistration: '',
                    companyName: '',
                    personalAddress: '',
                    personalAddressDetail: '',
                  }
                },
                paymentMethod: {
                  method: null,
                  taxBill: false,
                  cashReceiptPhoneNumber: null,
                },
                savedSign: null,
                totalAmount: 0,
              };

              
              
              setSelectedOptions({ ...initialBookingOption })
              dispatch(updateAll(initialBookingOption))
            }
            
            dispatch(closeLoading())
            
          }
          else {
              const initialBookingOption = {
                subscription: 'annual',
                usageTime: 'annual_1year_100h',
                optionHex: 0,
                vehicleOption: {
                  numberOfVehicles: 'twoVehicles',
                  roleOfVehicles: 'driver',
                  carAmount: 'twomilliondown',
                  insurance: 'insubasic',
                  passengerPerson: 'persontwo'
                },
                contractTerms1: {
                  periodOfContract: 'month1',
                  serviceArea: {
                    departure: {
                      zip: '',
                      address1: '',
                      address2: '',
                    },
                    destination: {
                      zip: '',
                      address1: '',
                      address2: '',
                    },
                  },
                  schedule: moment().add(1, 'days').format('yyyy-MM-DD'),
                },
                contractTerms2: {
                  purposeOfContract: 'business',
                  passenger: 'ceo',
                  passengerEtcString: '',
                  route: 'route_instagram',
                  routeEtcString: '',
                  vehicleName1: '',
                  vehicleName2: '',
                  vehicleName3: '',
                },
                userInformation: {
                  userType: 'personal',
                  user: {
                    name: '',
                    businessAddress: {
                      zip: '',
                      address1: '',
                      address2: '',
                    },
                    businessRegistrationId: '',
                    businessRegistration: '',
                    companyName: '',
                    personalAddress: '',
                    personalAddressDetail: '',
                  }
                },
                paymentMethod: {
                  method: null,
                  taxBill: false,
                  cashReceiptPhoneNumber: null,
                },
                savedSign: null,
                totalAmount: 0,
              };

              
              
              setSelectedOptions({ ...initialBookingOption })
              dispatch(updateAll(initialBookingOption))
            }
        }
        catch (e) {

        }
      }
    }

    initEstimateInfo()
  }, [])


  return (
    <>
      {
        (
          (location?.pathname?.indexOf('estimate') >= 0) ||
          (location?.pathname?.indexOf('confirm-contract') >= 0) ||
          (location?.pathname?.indexOf('estimate-download') >= 0)
        )
          ? null :
          <>
            <ShareButton type={'monthly'} />
          </>
      }
      <KakaoButton />


      {/* <AppDownloadButton /> */}
      <div className={'booking-estimation'}>

        <Header
          stepList={stepList}
          currentStep={currentStep}
          hasClose={true}
          hasPrevButton={true}
          title={'견적서 작성'} />
        <BookingBox>
          {!isPC && <Steps currentStep={currentStep} stepList={stepList} />}
          <Outlet />
        </BookingBox>
      </div>
    </>
    
  );
};

export default withBookingProvider(BookingEstimation);
